import React, { useId } from 'react';
import './logo.css';

const Logo = ({ isDarkBackground = true, size = 1, isAnimated = false }) => {
    const uniqueId = useId(); // unique for each Logo instance

    // Decide text color based on background
    const textColor = isDarkBackground ? 'white' : 'black';

    // Base dimensions
    const baseWidth = 260;
    const baseHeight = 100;
    const scaledWidth = baseWidth * size;
    const scaledHeight = baseHeight * size;

    const gradientId = `grad1-${uniqueId}`;

    return (
        <div className="logo-container">
            <svg
                width={scaledWidth}
                height={scaledHeight}
                viewBox={`0 0 ${baseWidth} ${baseHeight}`}
                xmlns="http://www.w3.org/2000/svg"
                style={{ 
                    '--font-color': textColor,
                    background: 'transparent',
                    overflow: 'visible' // Allow content to overflow SVG bounds
                }}
                preserveAspectRatio="xMidYMid meet">
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
                        {/* Stop #1 */}
                        <stop offset="0" stopColor="#10346C">
                            {isAnimated && (
                                <animate
                                    attributeName="stop-color"
                                    values="#10346C; #1B4E1F; #FF0000; #E1DD1B; #10346C"
                                    keyTimes="0; 0.25; 0.5; 0.75; 1"
                                    dur="8s"
                                    repeatCount="indefinite"
                                    calcMode="linear"
                                />
                            )}
                        </stop>

                        {/* Stop #2 */}
                        <stop offset="0.33" stopColor="#1B4E1F">
                            {isAnimated && (
                                <animate
                                    attributeName="stop-color"
                                    values="#1B4E1F; #FF0000; #E1DD1B; #10346C; #1B4E1F"
                                    keyTimes="0; 0.25; 0.5; 0.75; 1"
                                    dur="8s"
                                    repeatCount="indefinite"
                                    calcMode="linear"
                                />
                            )}
                        </stop>

                        {/* Stop #3 */}
                        <stop offset="0.66" stopColor="#FF0000">
                            {isAnimated && (
                                <animate
                                    attributeName="stop-color"
                                    values="#FF0000; #E1DD1B; #10346C; #1B4E1F; #FF0000"
                                    keyTimes="0; 0.25; 0.5; 0.75; 1"
                                    dur="8s"
                                    repeatCount="indefinite"
                                    calcMode="linear"
                                />
                            )}
                        </stop>

                        {/* Stop #4 */}
                        <stop offset="1" stopColor="#E1DD1B">
                            {isAnimated && (
                                <animate
                                    attributeName="stop-color"
                                    values="#E1DD1B; #10346C; #1B4E1F; #FF0000; #E1DD1B"
                                    keyTimes="0; 0.25; 0.5; 0.75; 1"
                                    dur="8s"
                                    repeatCount="indefinite"
                                    calcMode="linear"
                                />
                            )}
                        </stop>
                    </linearGradient>
                </defs>

                <text
                    x="10"
                    y="50"
                    className="logo-text"
                    fill={`url(#${gradientId})`}>
                    LiDAR Consultants
                </text>
                <rect
                    x="0"
                    y="55"
                    fill={`url(#${gradientId})`}
                    width={baseWidth}
                    height="5"
                />
            </svg>
        </div>
    );
};

export default Logo;
